import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import type { ModalOptions } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { Router } from '@angular/router';
// import { Location } from '@angular/common';

import {
    AddressVerificationService, AuthService, FirebaseFunctionsService, IsoCountriesService,
    IsoTimezonesService, UsersService
} from '@shared/services';
import { RadioModalPage, ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TCreateAccountInfo, TRegion, TIsoTimezone,
    TUser, TAccountCreationQuestionsAndAnswers, TCreateAccountResponseInfo, TApplicationFormViewModel
} from '@shared/models';

// const DateTimeFormats = Constants.DateTimeFormats;

@Component({
    'selector': 'app-apply3-login-credentials',
    'templateUrl': './apply3LoginCredentials.page.html',
    'styleUrls': ['./apply3LoginCredentials.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class Apply3LoginCredentialsPage extends ViewBasePage implements OnInit, OnDestroy {
    // private isoCountries: TIsoCountry[];
    // public isoTimezones: TIsoTimezones;
    public timezones: TIsoTimezone[];
    public regions: TRegion[];
    public vm: TApplicationFormViewModel;
    // private defaults: any = { 'efficiency': true, 'customer': true, 'campaign': true };
    public submitted = false;

    // private accountCreatorService: AccountCreatorService,
    constructor(private authService: AuthService, injector: Injector) {
        super(injector);
    }

    public override async ngOnInit() {
        super.ngOnInit();

        this.vm = this.getViewModel() as TApplicationFormViewModel;
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
    }
  
    public async onNextClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        if (!this.vm.questionsAndAnswers.hasReliableInternet) {
            await this.uxHelperService.showAlert('Qualification Required', 'A reliable internet connection is required for ShuttleNomix.');
            return;
        }

        if (!this.vm.questionsAndAnswers.locatedInUnitedStates) {
            const msg = 'Your dealership must be located in the United States to use ShuttleNomix.';
            await this.uxHelperService.showAlert('Qualification Required', msg);
            return;
        }

        if (!this.vm.questionsAndAnswers.isServiceManager) {
            const msg = 'You must be the service manager of the service department to create a ShuttleNomix account.';
            await this.uxHelperService.showAlert('Qualification Required', msg);
            return;
        }

        if (!this.vm.questionsAndAnswers.acceptsTrialTerms || !this.vm.questionsAndAnswers.commitsToOnboarding) {
            const msg = 'Please acknowledge the trial terms to proceed.';
            await this.uxHelperService.showAlert('Acknowledgment Required', msg);
            return;
        }

        // const isEmailAvailable = await this.authService.isEmailAddressAvailable(this.vm.email);
        if (!this.utilsService.validateEmailAddress(this.vm.user.email)) {
            const msg = 'This email address is already used.';
            await this.uxHelperService.showAlert('Invalid Email', msg);
            return;
        }

        const isEmailAvailable = await this.authService.isEmailAddressAvailable(this.vm.user.email);
        if (!isEmailAvailable) {
            const msg = 'This email address is already used.';
            await this.uxHelperService.showAlert('Invalid Email', msg);
            return;
        }

        try {
            await this.uxHelperService.showSpinner('Creating account.');
            // const response: any = await this.accountCreatorService.registerAccount(this.vm);
            const info = this.buildCreateAccountInfo();
            // console.log('info', info);
            const response: TCreateAccountResponseInfo =
                await this.firebaseFunctionsService.createAccount(info) as TCreateAccountResponseInfo;
            await this.uxHelperService.hideSpinner();

            // Do not automatically go back to accounts.  We need to display the password.
            // this.router.navigateByUrl('/accounts');

            if (response) {
                this.vm.password = response.password;
                this.vm.claims = JSON.stringify(response.claims);

                let msg = 'Success. Your account has been created with login credentials: ';
                msg += 'Email = ' + this.vm.user.email + ', Password = ' + response.password;
                msg += '.  The first thing you should do is go to the login page and change your password.';
                await this.uxHelperService.showAlert('Important', msg);
            } else {
                await this.uxHelperService.showAlert('Error', 'Something went wrong.');
            }
        } catch (err) {
            this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        } 

        // This code is looking in the users collection; which requires an account number.
        // Since we don't have an account number at this point, we can't do this check.  
        // We will rely on the Firebase function to do this check and return an error if 
        // the cell phone number is already used.  Long term, create a separate collection 
        // that is not account-specific to track used cell phone numbers and email addresses.
        //ptb const user = await this.usersService.getByCellPhone(this.vm.cellPhone);
        // if (user) {
        //     await this.uxHelperService.showAlert('Invalid Cell Number', 'This cell phone number is already used.');
        //     return;
        // }

        try {
            //ptb            await this.uxHelperService.showSpinner('Creating account.');
            // const response: any = await this.accountCreatorService.registerAccount(this.vm);
            const info = this.buildCreateAccountInfo();
            // console.log('info', info);
            const response: TCreateAccountResponseInfo =
                await this.firebaseFunctionsService.createAccount(info) as TCreateAccountResponseInfo;
            await this.uxHelperService.hideSpinner();

            // Do not automatically go back to accounts.  We need to display the password.
            // this.router.navigateByUrl('/accounts');

            if (response) {
                this.vm.password = response.password;
                this.vm.claims = JSON.stringify(response.claims);

                let msg = 'Success. Your account has been created with login credentials: ';
                msg += 'Email = ' + this.vm.user.email + ', Password = ' + response.password;
                msg += '.  The first thing you should do is go to the login page and change your password.';
                await this.uxHelperService.showAlert('Important', msg);
            } else {
                await this.uxHelperService.showAlert('Error', 'Something went wrong.');
            }
        } catch (err) {
            this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    private buildCreateAccountInfo(): TCreateAccountInfo {
        // const expires = this.dateService.addToNow(15, 'days', true);
        // const expirationDate = this.dateService.formatTimestamp(expires, DateTimeFormats.ShortDate)

        const managerInfo: TUser = {
            'firstName': this.vm.user.firstName,
            'lastName': this.vm.user.lastName,
            'cellPhone': this.utilsService.unformatPhoneNumber(this.vm.user.cellPhone),
            'email': this.vm.user.email,
            'role': 'manager',
            'uid': ''
        };

        const questionsAndAnswers: TAccountCreationQuestionsAndAnswers = {
            'hasReliableInternet': this.vm.questionsAndAnswers.hasReliableInternet,
            'locatedInUnitedStates': this.vm.questionsAndAnswers.locatedInUnitedStates,
            'isServiceManager': this.vm.questionsAndAnswers.isServiceManager,
            'acceptsTrialTerms': this.vm.questionsAndAnswers.acceptsTrialTerms,
            'commitsToOnboarding': this.vm.questionsAndAnswers.commitsToOnboarding
        };

        const info: TCreateAccountInfo = {
            // Manager Info
            'user': managerInfo,
            'questionsAndAnswers': questionsAndAnswers


            // Other Info
            // 'phonePrefixes': this.vm.phonePrefixes,
            // 'expirationDate': expires,
            // 'tags': [],
            // 'lists': [],
            // this.vm.countryName   = country.countryName;
            // this.vm.countryAbbr   = country.countryAbbr;
            // this.vm.countryCode   = country.isoCountryCode;
            // 'accountNumber': this.vm.accountNumber,
            // 'affiliateId': this.vm.affiliateId,
            // 'signupCouponCode': this.vm.couponCode,
            // dealership: undefined,
            // isoRegionCode: ''
        };

        // console.log('info = ', JSON.stringify(info));
        return info;
    }
}
